'use strict';
import forEach from 'lodash/forEach';
import moment from 'moment';
import {NoteState} from '../../system/enums/NoteState';
import template from './project-export.html';
import {logger} from './logger';

const angular = require('angular');
const {extend} = angular;


ProjectExportController.$inject = [
  '$modal',
  '$scope',
  'papaParse',
  '$download',
  '$toast',
  '$ngRedux',
  'AuthService',
  'ProjectImportExportService',
  'NotificationService',
  'fetchUtils',
  'project',
  'projectName',
  'assetLevel',
  'type',
  'TOAST_TYPES',
];

CacheTemplates.$inject = [
  '$templateCache',
];

export function CacheTemplates($templateCache) {
  $templateCache.put('projects/project-export.html', template);
}

// TODO: add support for toggling individual headers. Such a method will need to automatically include/exclude required/dependent headers
export function ProjectExportController(
  $modal,
  $scope,
  papaParse,
  $download,
  $toast,
  $ngRedux,
  AuthService,
  ProjectImportExportService,
  NotificationService,
  fetchUtils,
  project,
  projectName,
  assetLevel,
  type,
  TOAST_TYPES,
) {
  const vm = $scope.projectExport = this;
  projectName += '.csv';

  vm.exportProject = exportProject;
  vm.cancel = $modal.cancel.bind($modal);
  vm.toggleIncludeRequirements = toggleIncludeRequirements;

  vm.includeRequirements = true;

  _initHeaders();

  $scope.$watch('projectExport.includeRequirements', toggleIncludeRequirements);

  function toggleIncludeRequirements() {
    const length = vm.headers.length;
    let i = 0;

    if (!vm.includeRequirements) {
      for (; i < length; i++) {
        if (vm.headers[i].label.indexOf('requirement') > -1) {
          vm.headers[i].selected = false;
        }
      }
    } else {
      for (; i < length; i++) {
        vm.headers[i].selected = true;
      }
    }
  }

  function exportProject() {
    const length = vm.headers.length;
    const headers = [];

    for (let i = 0; i < length; i++) {
      if (vm.headers[i].selected) {
        headers.push(vm.headers[i].label);
      }
    }

    const body = {headers};
    if (type) body.type = type;
    const request = {
      method: 'POST',
      mode: 'cors',
      cache: 'default',
      contentType: 'json',
      body: body,
    };

    const collection = assetLevel ? 'asset-projects' : 'projects';
    const url = `${fetchUtils.API_URL}/api/${collection}/${project}/_export`;
    const requestPromise = fetchUtils.rawRequestWithAuth(url, request);

    const state = $ngRedux.getState().model;
    const projectName = assetLevel && state.asset
      ? `${state.project.name} | ${state.asset.name}`
      : state.project.name;

    // TODO(i18n)
    NotificationService.addNotification({
      name: `Export ${projectName} data`,
      removal: NotificationService.REMOVAL.ALWAYS, // change this if/when we add a retry save download button/behavior to the notification item
      promise: requestPromise,
      audio: {
        [NoteState.ERROR]: true,
      },
      toasts: {
        [NoteState.ERROR]: true,
      },
    });

    return requestPromise.then(_createOnSuccess(headers), _onError);
  }

  function _createOnSuccess(headers) {
    return function _onSuccess(response) {
      // prompt download of csv file containing data
      // logger.log('success!', response);

      try {
        const body = response.data;
        if (body.rows) {
          if (body.rows.length > 0) {
            const csvData = papaParse.unparse(_formatData(forceHeaders(headers, body.rows)));
            // logger.log('csv to export', csvData);

            $download.downloadAsTextFile(csvData, projectName);
          } else {
            return $toast.showI18nMessage({
              messageId: 'project.export.no.data.message',
              type: $toast.TOAST_TYPES.info,
            });
          }
        }
      } catch (e) {
        _onError(e);
      } finally {
        $modal.hide();
      }
    };
  }

  function _onError(err) {
    logger.error({err}, 'errors occurred');
    $toast.showI18nMessage({
      messageId: 'projects.export.failure.message',
      type: TOAST_TYPES.error,
    });
  }

  function forceHeaders(headers, data) {
    const headerObj = {};
    const output = [];

    for (let i = 0, length = headers.length; i < length; i++) {
      headerObj[headers[i]] = '';
    }

    for (let i = 0, length = data.length; i < length; i++) {
      output[i] = extend({}, headerObj, data[i]);
    }

    return output;
  }

  function _formatData(jsonData) {
    forEach(jsonData, function (row, key) {
      if (row.hasOwnProperty('task_scheduled') && row.hasOwnProperty('task_use_time')) {
        row.task_scheduled = _convertDate(row.task_scheduled, row.task_use_time);
      }
    });
    return jsonData;
  }

  function _convertDate(value, useTime) {
    if (!value) return null;

    try {
      const date = moment(value);
      if (useTime) {
        return date.format('L LT');
      } else {
        date.hours(0);
        return date.format('L');
      }
    } catch (e) {
      return null;
    }
  }

  function _initHeaders() {
    vm.headers = [];
    const HEADERS = ProjectImportExportService.getExportHeaders();
    for (const header in HEADERS) {
      if (HEADERS.hasOwnProperty(header)) {
        vm.headers.push({
          label: header, // TODO(i18n): may need to translate these? If so, need to add a separate property to store the value of the header
          selected: true,
        });
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/projects/modals/ProjectExportController.js